import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';

export default function JourneyUsecaseDialog({ usecaseModal, setUsecaseModal, usecaseLoading, usecaseContent }) {
  return (
    <Dialog open={!!usecaseModal} onOpenChange={(open) => !open && setUsecaseModal(null)}>
      <DialogContent className="max-w-3xl" data-testid="journey-usecase-dialog">
        <DialogHeader>
          <DialogTitle>
            {usecaseModal === 'job_interview' ? 'Job Interview Summary' : usecaseModal === 'court_compliance' ? 'Court Compliance Letter' : 'Personal Motivation'}
          </DialogTitle>
        </DialogHeader>
        {usecaseLoading ? (
          <div className="flex items-center justify-center h-32">
            <div className="w-6 h-6 border-2 border-violet-500 border-t-transparent rounded-full animate-spin" />
          </div>
        ) : (
          <div className="whitespace-pre-line text-sm text-slate-700" data-testid="journey-usecase-content">
            {usecaseContent}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
